import { render } from "./futuresAccount.vue?vue&type=template&id=19b2487e&scoped=true"
import script from "./futuresAccount.vue?vue&type=script&lang=js"
export * from "./futuresAccount.vue?vue&type=script&lang=js"

import "./futuresAccount.vue?vue&type=style&index=0&id=19b2487e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b2487e"]])

export default __exports__